import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAnimateNumber from 'vue-animate-number'
import VueAMap from 'vue-amap'
// import Mock from '@/assets/mock/mock'
import Axios from 'axios'
import VueCookies from 'vue-cookies'
import Api from '@/api/api'

Vue.use(VueAMap)
Vue.use(VueAnimateNumber)
Vue.use(ElementUI)
Vue.use(VueCookies)

Vue.prototype.$axios = Axios
Vue.prototype.$api = Api

Vue.prototype.bus = new Vue()

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德地图api开放平台申请的key  dd4cc5f831b67cde767de9a65f983650
  // key: '973068697c055b5143b10347ab6a522e',
  key: 'dd4cc5f831b67cde767de9a65f983650',
  // 插件集合 用什么放什么 放多余的加载会很慢
  // plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geocoder','AMap.CitySearch'],
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation'],
  // plugin: ['AMap.ToolBar', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
})
// 解决高德地图刷新显示不出来
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
amapKeys.forEach(key => { localStorage.removeItem(key) })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
